<div id="task-filter-view" class="page-layout blank">
  <div class="content">
    <div class="left">
      <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
        <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
          <div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0'">
            <div>
              <div class="p-10 headercmp overflow-hidden" fxlayout="row" fxlayoutalign="space-between center">
              <div class="p-10">
                <div class="h3 pr-16 p-b-10 cardHeader float-left">Plantillas LOPD</div>
                <button mat-icon-button (click)="addNewTemplate()" class="add-button add-template">
                  <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
                </button>
              </div>
              

                <div class="p-10 lopd-content">
                  <div class="inner-card p-b-10 ">
                    <div *ngIf="IsLoading == true" class="m-auto">
                      <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                      </mat-progress-spinner>
                    </div>

                    <mat-paginator class="table-pager lopd-paginator" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                    </mat-paginator>


                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" id="select-task-tbl">
                      <caption></caption>
                      <!-- <ng-container matColumnDef="plantillaId">
                        <th mat-header-cell *matHeaderCellDef id="id"> PlantillaId </th>
                        <td mat-cell *matCellDef="let template"> {{template.plantillaId}} </td>
                      </ng-container> -->

                      <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef id="name"> Nombre </th>
                        <td mat-cell *matCellDef="let template"> {{template.nombre}} </td>
                      </ng-container>

                      <!-- <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef id="path"> Path </th>
                        <td mat-cell *matCellDef="let template"> {{template.path}} </td>
                      </ng-container> -->

                      <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef id="actions"> </th>
                        <td mat-cell *matCellDef="let template">
                          <button aria-haspopup="true" class="navbar-toggle-button mat-icon-button icn-person"
                            (click)="downloadTemplate(template)">
                            <span class="mat-button-wrapper">
                              <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                cloud_download </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""
                              ng-reflect-centered="true"></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>
                          <button aria-haspopup="true" class="navbar-toggle-button mat-icon-button icn-person"
                            (click)="editTemplate(template)">
                            <span class="mat-button-wrapper">
                              <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                edit </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""
                              ng-reflect-centered="true"></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>
                          <button aria-haspopup="true" class="navbar-toggle-button mat-icon-button icn-person"
                            (click)="confirmDialog(template)">
                            <span class="mat-button-wrapper">
                              <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">
                                delete_outline </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""
                              ng-reflect-centered="true"></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> 
                    </table>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>